<mat-card class="todo-card about-card" appearance="raised">
  <mat-card-header>
    <mat-card-title>About Keeperoon</mat-card-title>
    <mat-card-subtitle>Simple task lists for quick daily focus.</mat-card-subtitle>
  </mat-card-header>

  <mat-card-content class="about-content">
    <p>Keeperoon helps you organize tasks by lists and finish what matters first.</p>
    <p>version: <strong>{{ buildVersion }}/{{ backendVersion }}</strong></p>

    <ng-container *ngIf="debugVisible">
      <p>Telegram runtime: <strong>{{ isTelegramWebApp ? 'yes' : 'no' }}</strong></p>
      <p>initData present: <strong>{{ hasTelegramInitData ? 'yes' : 'no' }}</strong></p>
      <p>Validation: <strong>{{ telegramVerifyState }}</strong> ({{ telegramVerifyMessage }})</p>

      <details>
        <summary>Telegram initData (raw)</summary>
        <pre>{{ telegramInitDataRaw || 'empty' }}</pre>
      </details>

      <details>
        <summary>Telegram initData (parsed)</summary>
        <pre>{{ telegramInitDataEntries | json }}</pre>
      </details>

      <details>
        <summary>Telegram initDataUnsafe</summary>
        <pre>{{ telegramInitDataUnsafeDebug || 'empty' }}</pre>
      </details>

      <details>
        <summary>Window location</summary>
        <pre>{{ { href: debugLocationHref, search: debugLocationSearch, hash: debugLocationHash } | json }}</pre>
      </details>

      <details>
        <summary>Backend validation response</summary>
        <pre>{{ telegramVerifyResponseDebug || 'no response yet' }}</pre>
      </details>

      <details>
        <summary>Backend validation error</summary>
        <pre>{{ telegramVerifyErrorDebug || 'no error' }}</pre>
      </details>
    </ng-container>
  </mat-card-content>
</mat-card>
